import { Controller } from "@hotwired/stimulus"

// Handles optimistic UI feedback for add-to-cart forms
export default class extends Controller {
  static targets = ["button"]
  static values = {
    resetAfter: { type: Number, default: 5000 }
  }

  connect() {
    this.originalMarkup = null
    this.resetTimeout = null
  }

  disconnect() {
    this.clearResetTimer()
  }

  submitStart() {
    if (!this.buttonTarget) return

    this.captureOriginalMarkup()
    this.buttonTarget.disabled = true
    this.buttonTarget.classList.add("opacity-90", "cursor-not-allowed")
  }

  submitEnd(event) {
    if (!this.buttonTarget) return

    this.buttonTarget.classList.remove("opacity-90", "cursor-not-allowed")

    if (event.detail.success) {
      this.showSuccessState()
    } else {
      this.restoreOriginalMarkup()
    }
  }

  showSuccessState() {
    this.clearResetTimer()

    this.buttonTarget.innerHTML = `
      <span class="flex items-center uppercase justify-center gap-2 bg-cinder text-white px-4 py-2 rounded-full font-denim-medium text-[14px] w-40 md:w-50 h-12 inline-flex items-center justify-center">
        Added
      </span>
    `
    this.buttonTarget.disabled = false

    this.resetTimeout = setTimeout(() => this.restoreOriginalMarkup(), this.resetAfterValue)
  }

  restoreOriginalMarkup() {
    this.clearResetTimer()

    if (this.originalMarkup) {
      this.buttonTarget.innerHTML = this.originalMarkup
    }

    this.buttonTarget.disabled = false
  }

  captureOriginalMarkup() {
    if (!this.originalMarkup) {
      this.originalMarkup = this.buttonTarget.innerHTML
    }
  }

  clearResetTimer() {
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout)
      this.resetTimeout = null
    }
  }
}
